import { AudioCircleIcon, PdfCircleIcon } from '@/components/icon'

interface Props {
  type: 'voice' | 'pdf'
  onClick?: () => void
  isThemselves?: boolean
}
export const ReadButton: React.FC<Props> = ({
  type,
  onClick,
  isThemselves = false,
}) => {
  const isVoice = type === 'voice'
  return (
    <div
      className={[
        'relative py-[15px] px-[10px] mb-[5px] w-full text-[15px] font-normal leading-6 text-left text-white hover:no-underline align-middle whitespace-nowrap border-b-2 border-solid cursor-pointer hover:outline-none rounded sm:table flex',
        isVoice
          ? 'bg-[#1ea0c5] border-b-[#137692] hover:bg-[#137692] hover:border-[#137692]'
          : 'bg-[#fd8637] border-b-[#bf6224] hover:bg-[#bf6224] hover:border-[#bf6224]',
      ].join(' ')}
      onClick={onClick}
    >
      <div className="w-[50px] h-[50px]">
        {isVoice ? (
          <>
            <AudioCircleIcon className="w-[50px] h-[50px]" />
            <div className="inline-block sm:table-cell pl-[15px] sm:pl-0 my-auto align-middle sm:align-top"></div>
            {isThemselves && (
              <div className="absolute top-[-10px] right-[-10px] z-[100] w-[50px] h-[50px] text-xs leading-6 text-center bg-[#fc0] rounded-[50%]">
                <p className="relative top-1/2 leading-[1.4] translate-y-[-50%]">
                  本人
                  <br />
                  登場!
                </p>
              </div>
            )}
          </>
        ) : (
          <PdfCircleIcon className="w-[50px] h-[50px]" />
        )}
      </div>
      {isVoice ? (
        <div className="inline-block sm:table-cell pl-[15px] sm:pl-0 my-auto align-middle sm:align-top">
          {isThemselves ? (
            <>
              この音声は著者本人が
              <br />
              読んでいます！
            </>
          ) : (
            <>
              この本の要約を
              <br className="pc" />
              音声で聴く
            </>
          )}
        </div>
      ) : (
        <div className="inline-block sm:table-cell pl-[15px] sm:pl-0 my-auto align-middle sm:align-top">
          この本の要約を
          <br className="pc" />
          PDFで閲覧
        </div>
      )}
    </div>
  )
}
